import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private OffersPosition Types */
import {
  Settings,
  _OfferPosition
} from '../namespace-helper'

import _ from 'lodash'

const selectedOfferPositionTemplate = {
  id: 0,
  customers_offers_id: 0,
  products_id: 0,
  inquiries_id: 0,
  units_id: 28,
  suppliers_offers_positions_id: 0,
  vats_id: 0,
  product: {
    reference: '',
    manufacturer: {
      name: ''
    }
  },
  delivery_time: {
    value: null
  },
  unit_sales_price: '',
  total_sales_price: '',
  customers_offers_positions_discounts: [],
  customers_offers_positions_commissions: [],
  customers_offers_positions_additional_costs: [],
  description: ''
}

export default {
  namespaced: true,
  state: {
    offersPositions: [],
    setSelectedOfferPosition: _.cloneDeep(selectedOfferPositionTemplate),
    openDialog: false,
    openCalculateDialog: false,
    offerPositionDiscountRemoving: false,
    offerPositionCommissionRemoving: false,
    offerPositionAddCostsRemoving: false
  },
  mutations: {
    [_OfferPosition.mutations.setOffersPositions] (state, payload) {
      state.offersPositions = payload
    },
    [_OfferPosition.mutations.setSelectedOfferPosition] (state, payload) {
      if (payload !== null) {
        if (payload.delivery_time === null) {
          payload.delivery_time = {
            value: null
          }
        }
        if (payload.customers_offers_positions_discounts === null) {
          payload.customers_offers_positions_discounts = []
        }
        if (payload.customers_offers_positions_commissions === null) {
          payload.customers_offers_positions_commissions = []
        }
        if (payload.customers_offers_positions_additional_costs === null) {
          payload.customers_offers_positions_additional_costs = []
        }
        state.setSelectedOfferPosition = payload
      } else {
        state.setSelectedOfferPosition = _.cloneDeep(selectedOfferPositionTemplate)
      }
    },
    [_OfferPosition.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_OfferPosition.mutations.setOpenCloseCalculateDialogState] (state) {
      state.openCalculateDialog = !state.openCalculateDialog
    },
    [_OfferPosition.mutations.setRemovingOfferPositionDiscount] (state, payload) {
      state.offerPositionDiscountRemoving = payload
    },
    [_OfferPosition.mutations.setRemovingOfferPositionCommission] (state, payload) {
      state.offerPositionCommissionRemoving = payload
    },
    [_OfferPosition.mutations.setRemovingOfferPositionAddCosts] (state, payload) {
      state.offerPositionAddCostsRemoving = payload
    }
  },
  actions: {
    [_OfferPosition.actions.saveOfferPosition] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/customerOfferPositions'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_OfferPosition.mutations.setSelectedOfferPosition, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/customerOfferPositions/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_OfferPosition.actions.saveOfferPositions] (context, payload) {
      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        const url = API_URL + '/api/v1/customerOfferPositions/batch/update'

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_OfferPosition.actions.loadOffersPositions] (context, payload) {
      console.log('loadOffersPositions: ' + JSON.stringify(payload))
      console.log('loadOffersPositions: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/customerOfferPositions/offer/' + payload.id + '?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;product.reference:like;product.manufacturer.name:like;quantity:like;customersOffersPositionsStatus.name:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadOffersPositions: ' + JSON.stringify(r.data.data))
        context.commit(_OfferPosition.mutations.setOffersPositions, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_OfferPosition.actions.removeOfferPositionDiscount] (context, payload) {
      context.commit(_OfferPosition.mutations.setRemovingOfferPositionDiscount, true)

      var url = API_URL + '/api/v1/customerOfferPositionDiscounts/' + payload

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_OfferPosition.mutations.setRemovingOfferPositionDiscount, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_OfferPosition.mutations.setRemovingOfferPositionDiscount, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_OfferPosition.actions.removeOfferPositionCommission] (context, payload) {
      context.commit(_OfferPosition.mutations.setRemovingOfferPositionCommission, true)

      var url = API_URL + '/api/v1/customerOfferPositionCommissions/' + payload

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_OfferPosition.mutations.setRemovingOfferPositionCommission, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_OfferPosition.mutations.setRemovingOfferPositionCommission, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_OfferPosition.actions.removeOfferPositionAddCosts] (context, payload) {
      context.commit(_OfferPosition.mutations.setRemovingOfferPositionAddCosts, true)

      var url = API_URL + '/api/v1/customerOfferPosAdditionalCosts/' + payload

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_OfferPosition.mutations.setRemovingOfferPositionAddCosts, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_OfferPosition.mutations.setRemovingOfferPositionAddCosts, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_OfferPosition.actions.openCloseDialog] ({ commit }) {
      commit(_OfferPosition.mutations.setOpenCloseDialogState)
    },
    [_OfferPosition.actions.openCloseCalculateDialog] ({ commit }) {
      commit(_OfferPosition.mutations.setOpenCloseCalculateDialogState)
    },
    [_OfferPosition.actions.setSelectedOfferPosition] ({ commit }, payload) {
      commit(_OfferPosition.mutations.setSelectedOfferPosition, payload)
    },
    [_OfferPosition.actions.resetOffersPositions] ({ commit }) {
      commit(_OfferPosition.mutations.setOffersPositions, [])
    },
    [_OfferPosition.actions.resetState] ({ commit }) {
      commit(_OfferPosition.mutations.setOffersPositions, [])
      commit(_OfferPosition.mutations.setSelectedOfferPosition, null)
    }
  },
  getters: {
    [_OfferPosition.getters.offersPositions] (state) {
      return state.offersPositions
    },
    [_OfferPosition.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_OfferPosition.getters.getOpenCalculateDialogState] (state) {
      return state.openCalculateDialog
    },
    [_OfferPosition.getters.getSelectedOfferPosition] (state) {
      return state.setSelectedOfferPosition
    },
    [_OfferPosition.getters.getRemovingOfferPositionDiscount] (state) {
      return state.offerPositionDiscountRemoving
    },
    [_OfferPosition.getters.getRemovingOfferPositionCommission] (state) {
      return state.offerPositionCommissionRemoving
    },
    [_OfferPosition.getters.getRemovingOfferPositionAddCosts] (state) {
      return state.offerPositionAddCostsRemoving
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/OfferPosition/offersPositions.js